<template>
  <div id="spreadsheet" ref="spreadsheet" style="overflow-x: auto; width: 100%"></div>
</template>


<script>

export default {
  name: "SpreadSheet",
  props:{
    collumns: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    canEdit: {
      type: Boolean,
      default: true
    },
    isSingleEdit: {
      type: Boolean,
      default: false
    },
    tempColWidth: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      hiddenCollumns: [
        {type: 'hidden', title: '', name: 'id', width: '0'},
        //{type: 'hidden', title: '', name: 'bis_id', width: '0'},
      ],
      testingMinRows: 4,
      editId: '',
    }
  },
  computed: {
    cols () {
      return [...this.hiddenCollumns, ...this.collumns];
    }
  },
  watch: {
  },
  mounted: function() {
    //this.mountSpreadsheet();
  },
  methods: {
    mountSpreadsheet() {
      console.log(this.data)
      const spreadsheet = jspreadsheet(this.$el, {
        data: [...this.data],
        freezeColumns: 3,
        allowToolbar:true,
        columnDrag:false,
        rowDrag: false,
        minDimensions:[this.collumns.length, this.data.length],
        tableWidth: '100%',
        tableHeight: '100%',
        autoIncrement: false,
        tempColWidth: this.tempColWidth,
        filters: true,
        tableOverflow: true,
        columns: this.cols,
        editable: this.canEdit,
        canundo: !this.isSingleEdit,
        canredo: !this.isSingleEdit,
        //onevent:this.onevent,
        onchange:this.onchange,
        updateTable:this.updateTable,
        onselection:this.onselection,
        onrowdblclick: this.onRowDblClick,
      });
      // Target the headers to allow single-click sorting
      document.querySelectorAll('.jexcel thead td:not(.jexcel_column_filter)').forEach((el, index) => {
        el.addEventListener('click', function() {
          console.log("header click")
          // index - 1 if you have row numbers enabled
          spreadsheet.orderBy(index - 1);
        });
      });
      // Add hints to headers
      document.querySelectorAll('.jexcel thead td:not(.jexcel_column_filter)').forEach((el) => {
        el.setAttribute('title', 'Zum sortieren klicken.');
      });
      Object.assign(this, {spreadsheet});
    },
    onevent(a, b, c, d, f, g, h, z, a1, a2) {
      console.log("asdf")
      console.log(a);
      console.log(b);
      console.log(c);
      console.log(d);
      console.log(f);
      console.log(g);
      console.log(h);
      console.log(z);
      console.log(a1);
      console.log(a2);

    },
    onselection(el, borderLeft, borderTop, borderRight, borderBottom, origin, canDelete) {
      this.$emit('selection-change', canDelete, this.spreadsheet.getSelectedRows(true));
    },
    onRowDblClick(index) {
      this.$emit('dbl-click', index);
    },
    toggleRowLock(rowId) {
      let d = this.spreadsheet.getData();
      for (let i = 0; i < d.length; i++) {
        let enabled = rowId === '';
        if (d[i][0] === rowId) {
          enabled = true;
        }
        for (let j = 0; j < d[i].length; j++) {
          if (enabled && (!this.cols[j].readOnly || (d[i][1] === 'Neuanlage' && j !== 1))) {
            this.spreadsheet.getCellXY(i, j).classList.remove('readonly');
          } else {
            this.spreadsheet.getCellXY(i, j).classList.add('readonly');
          }
        }
      }
    },
    onchange(el, td, x, y, valOld, valNew) {
      if (valOld !== valNew && this.editId === '') {
        if (this.isSingleEdit) {
          this.editId = this.spreadsheet.getRowData(y)[0];
          this.toggleRowLock(this.editId);
        }
        this.$emit('change', this.editId);
      }
    },
    updateTable(el, cell, x, y, source, value, id) {
      if (this.cols[x].required && value === '') {
        cell.classList.add('val-error');
      } else {
        cell.classList.remove('val-error');
      }
    },
    addRow(data) {
      this.spreadsheet.insertRow(data);
      if (this.isSingleEdit) {
        this.editId = data.id;
        this.toggleRowLock(this.editId)
      }
      this.$emit('change', this.editId);
    },
    getData(id) {
      let res = {};
      let d = this.spreadsheet.getData();
      for (let i = 0; i < d.length; i++) {
        if (d[i][0] === id) {
          for (let j = 0; j < this.cols.length; j++) {
            res[this.cols[j].name] = d[i][j]
          }
          break;
        }
      }
      return res;
    },
    getAllData() {
      let res = [];
      let d = this.spreadsheet.getData();
      for (let i = 0; i < d.length; i++) {
        let row = {};
        for (let j = 0; j < this.cols.length; j++) {
          row[this.cols[j].name] = d[i][j]
        }
        res.push(row);
      }
      return res;
    },
    updateRow(data) {
      let d = this.spreadsheet.getData();
      for (let i = 0; i < d.length; i++) {
        if (d[i][0] === data.id) {
          this.spreadsheet.setRowData(i, data, true);
          break;
        }
      }
      this.spreadsheet.resetSelection();
      this.editId = '';
      this.toggleRowLock(this.editId);
    },
    deleteRows(index, num) {
      this.spreadsheet.deleteRow(index, num, true);
      this.spreadsheet.resetSelection();
      this.editId = '';
      this.toggleRowLock(this.editId);
    },
    resetEdit(id) {
      let data = null;
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].id === id) {
          data = this.data[i];
          break;
        }
      }
      if (data) {
        let d = this.spreadsheet.getData();
        for (let i = 0; i < d.length; i++) {
          if (d[i][0] === id) {
            this.spreadsheet.setRowData(i, data);
            break
          }
        }
      } else {
        let d = this.spreadsheet.getData();
        for (let i = 0; i < d.length; i++) {
          if (d[i][0] === id) {
            this.spreadsheet.deleteRow(i, 1, true);
            break
          }
        }
      }
      this.spreadsheet.resetSelection();
      this.editId = '';
      this.toggleRowLock(this.editId);
    },
    reload() {
      this.spreadsheet.setData([...this.data]);
    }
  }
}
</script>

<style>
#spreadsheet {
  font-size: 14px!important;
  font-optical-sizing: auto!important;
  line-height: 1.8!important;
  font-style: normal!important;
}
#spreadsheet .jexcel_nested  td:nth-child(2) {
  color: #3061f5 !important;
  font-weight: 700;
}

#spreadsheet .jexcel {
  width:  100%!important;
}

#spreadsheet .jexcel_content {
  box-shadow: none !important;
}

#spreadsheet .jexcel_selectall::after {
  content: ' ';
  border-bottom: 12px solid #ccc !important;
  border-left: 12px solid transparent;
  width: 0;
  position: absolute;
  bottom: 3px;
  right: 3px;
}

#spreadsheet .val-error {
  background-color: rgba(252, 163, 169, 0.92);
}

#spreadsheet .jexcel_column_filter {
  background-color: #fdfdfd;
  position: initial;
}

#spreadsheet .jdropdown-item {
  text-transform: none !important;
}

#spreadsheet .jexcel > tbody > tr > td.readonly {
  background-color: #f8f8f8;
  color: black;
}

</style>
